import Skeleton from '../../../shared/components/UI/Skeleton/Skeleton';

const GameCardSkeleton = () => {
    return (
        <div className="gameCard">
            <div className="gameCard-container">
                <div className="gameCard-preview-container" style={{ 
                    height: '207px', 
                    borderRadius: '20px', 
                    overflow: 'hidden', 
                    marginBottom: '6px',
                    backgroundColor: '#28282C'
                }}>
                    <Skeleton width="100%" height="100%" borderRadius="8px" />
                </div>
                
                <div className="gameCard_tag" style={{ display: 'flex', gap: '8px', marginTop: '12px' }}>
                    <Skeleton width="70px" height="28px" borderRadius="28px" />
                    <Skeleton width="90px" height="28px" borderRadius="28px" />
                </div>
                
                <div className="gameCard-info">
                    <h3 className="gameCard-name">
                        <Skeleton width="80%" height="24px" borderRadius="4px" />
                    </h3>
                    
                    <div className="gameCard-textContainer">
                        <p className="gameCard-info-text gameCard-info-date">
                            <Skeleton width="120px" height="16px" borderRadius="4px" />
                        </p>
                        <p className="gameCard-info-text gameCard-info-place">
                            <Skeleton width="90%" height="16px" borderRadius="4px" />
                        </p>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default GameCardSkeleton;